import { useState, useEffect, useContext }  from "react"; // 🔴 faltava tudo isso
import UserTable                            from "./UserTable"; // 🔴 faltando
import LoadingTable                         from '../Table/LoadingTable.js' // 🔴 faltando
import { usePushNotifications }             from '../../contexts/PushNotificationsContext.js' // 🔴 faltando
import { BackOfficeContext }                from "../../contexts/BackOfficeContext.js" // 🔴 faltando
import TemporaryPasswordModal               from '../Form/TemporaryPasswordModal.js'
import api                                  from '../../services/api.js' // 🔴 faltando

export default function UserTableContainer() {

    const [_usersData, _setUsersData] = useState(null)
    const [loading, setLoading] = useState(true) // 🔴 ALTERADO: nome correto
    const [resettingUserId, setResettingUserId] = useState(null)
    const [resetResult, setResetResult] = useState(null)

    const { setContentPushNotification } = usePushNotifications()
    const { updateUserTable, handlerUserModalOpenForEdit } = useContext(BackOfficeContext)

    useEffect(() => {

        const fetchUserTabelData = async () => { // 🔴 ALTERADO: função movida pra dentro

            try {

                setLoading(true) // 🔴 ALTERADO: loading começa aqui (antes estava fora)

                const response = await api.get('/getAllUsers')

                _setUsersData(response.data)

            } catch (error) {

                console.log(error)
                setContentPushNotification({
                    title: 'Erro',
                    message: 'Falha ao acessar os dados dos usuários'
                })

            } finally {
                setLoading(false) // 🔴 ALTERADO: sempre desliga loading
            }
        }

        fetchUserTabelData()

    }, [updateUserTable, setContentPushNotification]) 
    // 🔴 ALTERADO: removi fetchUserTabelData das deps

    const handlerResetPassword = async (userData) => {

        // A senha atual do usuário é destruída aqui — se ele ainda tiver acesso,
        // vai perder. Confirmação explícita antes de qualquer chamada.
        const confirmado = window.confirm(
            `Redefinir a senha de ${userData.fullName} (${userData.username})?\n\n` +
            `A senha atual deixa de funcionar imediatamente e uma senha provisória ` +
            `será gerada para você entregar à pessoa.`
        )

        if (!confirmado) return

        try {

            setResettingUserId(userData.id)

            const response = await api.put('/resetPassword', { userId: userData.id })

            setResetResult(response.data)

        } catch (error) {

            console.log(error)
            setContentPushNotification({
                title: 'Erro',
                message: error.response?.data?.message || 'Falha ao redefinir a senha'
            })

        } finally {
            setResettingUserId(null)
        }
    }

    return (

        <>
            {loading ? (

                <div className="mt-[17px]">
                    <LoadingTable />
                </div>

            ) : (

                <UserTable
                    tableData={_usersData}
                    onEdit={handlerUserModalOpenForEdit}
                    onResetPassword={handlerResetPassword}
                    resettingUserId={resettingUserId}
                />

            )}

            <TemporaryPasswordModal
                isOpen={!!resetResult}
                dados={resetResult}
                onClose={() => setResetResult(null)}
            />
        </>

    )
}